"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagUS = function FlagUS(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-101.36H-193v-13.58a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "83.57",
    width: "409.6",
    height: "20.65",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "42.28",
    width: "409.6",
    height: "20.64",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6,22.5H-185.94A7.06,7.06,0,0,1-193,15.44V1.86H216.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "207.44",
    width: "409.6",
    height: "20.64",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.07,7.07,0,0,1-193,139.3V125.71H216.6V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "166.15",
    width: "409.6",
    height: "20.64",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-9.39-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V15.44a7.06,7.06,0,0,0,7.06,7.06H-9.39a7.06,7.06,0,0,0,7.07-7.06V-114.94A7.07,7.07,0,0,0-9.39-122Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-173.17-105.79l1.56,4.69,5,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-173.17-81.27l1.56,4.69,5,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-173.17-56.74l1.56,4.68,5,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-173.17-32.22l1.56,4.69,5,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-173.17-7.7-171.61-3l5,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2L-176-3l1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-154.13-93.77l1.56,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.5,4.71a.67.67,0,0,1-1,.74l-4-2.87-4,2.87a.67.67,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.69a.67.67,0,0,1,1.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-154.13-69.24l1.56,4.68,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.5,4.71a.67.67,0,0,1-1,.74l-4-2.87-4,2.87a.67.67,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.68a.67.67,0,0,1,1.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-154.13-44.72l1.56,4.69,4.94,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.5,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93A.67.67,0,0,1-161.9-40l4.94,0,1.56-4.69a.67.67,0,0,1,1.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-154.13-20.2l1.56,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.5,4.71a.67.67,0,0,1-1,.74l-4-2.87-4,2.87a.67.67,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.69a.67.67,0,0,1,1.27,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.1-105.79l1.56,4.69,4.95,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.1-81.27l1.56,4.69,4.95,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.1-56.74l1.56,4.68,4.95,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.1-32.22l1.56,4.69,4.95,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-135.1-7.7-133.54-3l4.95,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-116.07-93.77l1.57,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.5,4.71a.67.67,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-116.07-69.24l1.57,4.68,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.5,4.71a.67.67,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-116.07-44.72-114.5-40l4.94,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.5,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-116.07-20.2l1.57,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.5,4.71a.67.67,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-97-105.79l1.56,4.69,4.94,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.48-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-97-81.27l1.56,4.69,4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.48-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-97-56.74l1.56,4.68,4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.48-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-97-32.22l1.56,4.69,4.94,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.48-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-97-7.7-95.47-3l4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.48-4.71-4-2.94A.67.67,0,0,1-104.8-3l4.94,0,1.57-4.69A.66.66,0,0,1-97-7.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-78-93.77l1.57,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.48,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-78-69.24l1.57,4.68,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.48,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-78-44.72-76.43-40l4.94,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.48,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93A.67.67,0,0,1-85.76-40l4.94,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-78-20.2l1.57,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.48,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.66.66,0,0,1,.39-1.2l4.94,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59-105.79l1.56,4.69,4.94,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.48-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59-81.27l1.56,4.69,4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.48-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59-56.74l1.56,4.68,4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.48-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59-32.22l1.56,4.69,4.94,0a.67.67,0,0,1,.39,1.21l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.48-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-59-7.7-57.4-3l4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.48-4.71-4-2.94A.67.67,0,0,1-66.73-3l4.94,0,1.57-4.69A.66.66,0,0,1-59-7.7Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-39.93-93.77l1.57,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94A.67.67,0,0,1-47.7-89l5,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-39.93-69.24l1.57,4.68,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2l5,0,1.56-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-39.93-44.72-38.36-40l4.94,0A.67.67,0,0,1-33-38.79l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.49-4.71-4-2.93A.67.67,0,0,1-47.7-40l5,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-39.93-20.2l1.57,4.69,4.94,0a.67.67,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.66.66,0,0,1-1-.74l1.49-4.71-4-2.94a.67.67,0,0,1,.39-1.2l5,0,1.56-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.89-105.79l1.56,4.69,4.94,0A.67.67,0,0,1-14-99.86l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.5-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.89-81.27l1.56,4.69,4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.67.67,0,0,1-1-.74l1.5-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.89-56.74l1.56,4.68,4.94,0a.66.66,0,0,1,.39,1.2l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.67.67,0,0,1-1-.74l1.5-4.71-4-2.94a.67.67,0,0,1,.39-1.2l4.94,0,1.57-4.68a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.89-32.22l1.56,4.69,4.94,0A.67.67,0,0,1-14-26.29l-4,2.93,1.49,4.71a.67.67,0,0,1-1,.75l-4-2.88-4,2.88a.67.67,0,0,1-1-.75l1.5-4.71-4-2.93a.67.67,0,0,1,.39-1.21l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.89-7.7-19.33-3l4.94,0A.66.66,0,0,1-14-1.77l-4,2.94,1.49,4.71a.66.66,0,0,1-1,.74l-4-2.87-4,2.87a.67.67,0,0,1-1-.74l1.5-4.71-4-2.94A.67.67,0,0,1-28.66-3l4.94,0,1.57-4.69a.66.66,0,0,1,1.26,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagUS;
exports["default"] = _default;